<template>
  <div>
    <v-card
      elevation="0"
      :loading="categories.selected.loading"
      :disabled="categories.selected.loading"
      rounded="0"
    >
      <ViewHeader
        :goTo="checkParentCategorie"
        :title="categories.item ? categories.item.name : $organization.categoriesViewTitle()"
      />

      <h4 class="px-5 my-4 font-weight-regular text--secondary">
        {{ categoriesConfig.data.title }}
      </h4>

      <div
        class="text-center pa-5 ma-5"
        v-if="categories.loading"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          width="2"
        ></v-progress-circular>
      </div>
      <div v-else>
        <v-list
          subheader
          :disabled="categories.selected.loading"
        >
          <v-list-item-group :value="categories.selected.data">
            <template>
              <div
                v-for="(category, index) in categories.list"
                :key="`category-${index}`"
                @click="select(category, index), saveAnalytic()"
              >
                <v-list-item
                  class="px-5"
                  :two-line="!!category.description"
                >
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-html="category.name"></v-list-item-title>
                      <v-list-item-subtitle
                        style="line-height: 1.4"
                        v-if="category.description"
                        v-html="category.description"
                        class="mt-1"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <Icon
                        :color="'rgba(0,0,0,.54)'"
                        :icon="'chevron-right'"
                      />
                    </v-list-item-action>
                  </template>
                </v-list-item>
                <v-divider v-if="(index + 1) < categories.list.length"></v-divider>
              </div>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
    </v-card>
    <v-dialog
      v-model="cammerNoAvailable"
      overlay-opacity="0"
      max-width="290"
    >
      <v-card>
        <v-card-title>
          <b>{{ $t('queue.message.title') }}</b>
        </v-card-title>
        <v-card-text >
          <span>
            {{ $t(`messages.noAvailable`) }}
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="cammerNoAvailable = false"
            class="os-rounded"
          >
            <b>Salir</b>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'

require('@/services/Categories')

@Component({
  components: {
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  watch: {
    $route: function () {
      this.setCategories()
    }
  },
  computed: {
    categoriesConfig () {
      return this.$organization.categoriesConfig()
    },
    checkParentCategorie () {
      const route = this.categories.item ? (this.categories.item.parent_category_id ? `/categories/${this.categories.item.parent_category_id}` : '/categories') : '/'
      return route
    },
    formIsMain () {
      return this.$organization.formIsMain()
    }
  }
})
export default class CategoriesNav extends Vue {
  data () {
    return {
      categories: {
        loading: false,
        list: [],
        selected: {
          loading: false,
          data: null
        },
        item: null,
      },
      cammerNoAvailable: false
    }
  }

  mounted () {
    this.$store.state.storage.category = null
    this.$storage.updateStorageData()
    this.setCategories()
  }

  async next () {
    const category = this.categories.selected.data

    if (category.category_type_id === 2) {
      window.open(category.action)
    } else if (category.category_type_id === 3) {
      if (category.action.includes('wappf:')) {
        Function(category.action.split('wappf:')[1]).bind(this)()
      } else {
        window.parent.postMessage(category.action, '*')
      }
    } else if (this.$organization.calendaryModule() && this.$organization.directCallModule()) {
      this.categories.selected.loading = true

      this.$categories.activeCategory(category)
        .then(() => {
          const categorySetting = this.$store.state.categorySettings
          if (categorySetting.call && categorySetting.calendar) {
            this.$router.replace({ path: '/attention-types' })
          } else if (categorySetting.call) {
            this.goPath('/permissions', { requestChannel: true })
          } else if (categorySetting.calendar) {
            this.goPath('/calendar', { requestChannel: true })
          } else {
            this.cammerNoAvailable = true
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .then(() => {
          this.categories.selected.loading = false
        })
    } else if (this.$organization.calendaryModule()) {
      this.goPath('/calendar', { requestChannel: true })
    } else {
      this.goPath('/permissions', { requestChannel: true })
    }
  }

  goPath(path, query = {}) {
    this.$router.replace({ path: !this.formIsMain.isActive ? '/home' : path, query }).catch((error) => {})
  }

  saveAnalytic () {
    if (!this.categories.selected.data) {
      return false
    }

    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: `Seleccionó: ${this.categories.selected.data.name}`,
      detail: `El cliente seleccionó de la lista de ${this.$organization.categoriesViewTitle()}: ${this.categories.selected.data.name}`,
      actionType: 'STAH',
      functionality: 2,
      historyInteractionType: 'OSIFDV'
    })
  }

  clearSelected () {
    this.categories.selected.data = null
  }

  select (category) {
    this.categories.selected.data = category

    if (this.categories.selected.data.sub.length) {
      this.$router.replace({ path: `/categories/${this.categories.selected.data.id}` })
    } else {
      this.$store.state.storage.category = this.categories.selected.data
      this.$storage.updateStorageData()

      if (this.categories.selected.data.category_type_id && this.categories.selected.data.category_type_id !== 1) {
        this.saveCategorySummary(this.categories.selected.data)
      }

      this.next()
    }
  }

  setCategories () {
    if (this.$route.name === 'categories') {
      this.getCategoriesByOrganizationId()
    } else {
      this.getCategory()
    }
  }

  getCategoriesByCategory (category) {
    this.categories.list = category.sub
  }

  async getCategoriesByOrganizationId () {
    const data = {
      route: `ocular/widget/categories`,
      params: {}
    }

    this.categories.loading = true

    return MainService.get(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.categories.list = res.categories
          this.categories.item = null
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.categories.loading = false
      })
  }

  async getCategory () {
    const categoryId = this.$route.params.name

    const data = {
      route: `ocular/categories/${categoryId}`,
      params: {}
    }

    this.categories.selected.loading = true

    return MainService.get(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.categories.item = res.category
          this.categories.list = this.categories.item.sub
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.clearSelected()
        this.categories.selected.loading = false
      })
  }

  async saveCategorySummary(category) {
    const data = {
      route: `ocular/categories-summary`,
      params: {
        categoryId: category.id,
        questionnaryCode: this.$storage.storage.form.code
      }
    }

    return MainService.post(data)
      .catch((e) => {
        console.log(e)
      })
  }
}
</script>

<style scoped>
.v-list-item__subtitle, .v-list-item__title {
  white-space: normal !important;
  line-height: 1.4 !important;
}
</style>
